import { render } from "./ReviewCreateModal.vue?vue&type=template&id=552960d6&scoped=true"
import script from "./ReviewCreateModal.vue?vue&type=script&lang=js"
export * from "./ReviewCreateModal.vue?vue&type=script&lang=js"

import "./ReviewCreateModal.vue?vue&type=style&index=0&id=552960d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552960d6"]])

export default __exports__